import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { Button, GridDialog } from ".."
import { FormattedMessage } from "react-intl"
import alert from "./alert.svg"

const useStyles = makeStyles(theme => ({
  body: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(8, 0),
  },
  content: {
    width: "100%",
    maxWidth: theme.spacing(60),
    height: theme.spacing(45),
    margin: "auto",
  },
  title: {
    color: theme.palette.black.main,
    textAlign: "center",
    margin: "auto",
  },
  bodyText: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
    maxWidth: theme.spacing(45),
    margin: "auto",
  },
  leafLeft: {
    position: "absolute",
    left: 0,
    top: "10%",
    width: 80,
    height: 77,
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  leafRight: {
    position: "absolute",
    right: 0,
    bottom: "10%",
    width: 80,
    height: 77,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  payUText: {
    color: "#B7D100",
  },
  payULogo: {
    margin: theme.spacing(8, 0, 2, 0),
    position: "relative",
    left: "50%",
    transform: "translate(-50%)",
    height: theme.spacing(8),
  },
  btn: {
    left: '40%'
  }
}))

const checkoutErrors = props => {
  // eslint-disable-next-line
  const classes = useStyles()
  let isOpen = props.open
  const i18nmessages = props.i18nmessages

  if (isOpen) {
    return (
      <GridDialog fullScreen={"sm"} xs={8} open={isOpen}>
        <div className={classes.body}>
          <img src={props.bgImgLeft} className={classes.leafLeft} alt={""} />
          <img src={props.bgImgRight} className={classes.leafRight} alt={""} />
          <div className={classes.content}>
            <img src={alert} className={classes.payULogo} alt={""} />

            <Typography
              id={props.titleId}
              variant={"h4"}
              classes={{ root: classes.title }}
            >
              <FormattedMessage id="checkoutNotPermitted" />
            </Typography>

            <Typography classes={{ root: classes.bodyText }} variant={"body1"}>
              <FormattedMessage id="checkoutNotPermittedReason" />
            </Typography>

            <Button color={props.color || "green"} className={classes.btn} onClick={props.handleHide}>{i18nmessages.checkoutDismissModal}</Button>
          </div>
        </div>
      </GridDialog>
    )
  }

  return null;
}

export default checkoutErrors
